import {getTreeNodeByPath} from "../business-logic/tree-manager";
import {pop} from "./array-utils";
import {TABS} from "../conf/siroad";

export const hasHundredThreeInformative = nodeId => (nodeId !== TABS.general.id);
